const features = [
  {
    icon: 'ri-rocket-line',
    title: '快速上手',
    description: '17c.cc 提供简单直观的操作界面，新用户无需复杂学习即可快速掌握核心功能，注册后立即可用。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '17c.cc 采用行业领先的安全加密技术，全方位保障您的数据安全和隐私，让您用得安心放心。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '17c.cc 全面支持桌面端和移动端访问，随时随地畅享平台服务，无缝切换不同设备。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专属客服',
    description: '17c.cc 提供全天候客户服务支持，快速响应您的每一个需求，确保问题得到及时解决。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            为什么选择 17c.cc？
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            17c.cc 致力于为用户提供卓越的平台体验，以下是我们引以为豪的核心优势
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}